/* eslint-disable max-len */
export interface reqBodyPermission {
  resourceName: string | number,
  actions: string[],
  resourceID?: number | string,
}
class ApiRequests {
  static createWorkspaceBody(Name: string, description: String): Object {
    return {
      Name,
      Description: description,
    };
  }

  static editWorkspaceBody(Name: string): Object {
    return {
      action: 'update-name',
      actionData: {
        name: Name,
      },
    };
  }

  static createCloudAccssSecretBody(label: string, name: string, accessKey: string, secretKey?: String): Object {
    return {
      credsName: name,
      credsLabel: label,
      credsRotate: true,
      creds: { accessKey, secretKey },
    };
  }

  static createCloudDigitaltBody(label: string, name: string): Object {
    return {
      credsName: name,
      credsLabel: label,
      credsRotate: true,
    };
  }

  static createGCPCloudAuthorizationBody(label:string, name:string):Object {
    return {
      credsName: name,
      credsLabel: label,
      credsRotate: true,
    };
  }

  static createTencentCloudAuthorizationBody(label:string, name:string, providerId:string, roleArn:string):Object {
    return {
      credsName: name,
      credsLabel: label,
      credsRotate: true,
      providerId,
      roleArn,
    };
  }

  static createApiCredBody(name: String, staticToken: boolean, permissions: reqBodyPermission[]): Object {
    return {
      name,
      staticToken,
      permissions,
    };
  }
}
export default ApiRequests;